module.exports = __webpack_public_path__ + "img/pic1.e289290c.png";